export interface ClassificationOption {
    id: number;
    nombre: string;
}

export const optClassification1: ClassificationOption[] = [
    { id: 1, nombre: 'Fertilizante' },
    { id: 2, nombre: 'Acondicionador' },
];

export const optClassification2: ClassificationOption[] = [
    { id: 1, nombre: 'Orgánico' },
    { id: 2, nombre: 'Inorgánico' },
];

export const optClassification3: ClassificationOption[] = [
    { id: 1, nombre: 'Simple' },
    { id: 2, nombre: 'Compuesto' },
];

export const optProductiveStage: ClassificationOption[] = [
    { id: 1, nombre: 'Engorde' },
    { id: 2, nombre: 'Postura' },
];
